import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=7db8dfe6"
import script from "./Forgot.vue?vue&type=script&lang=ts"
export * from "./Forgot.vue?vue&type=script&lang=ts"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=7db8dfe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports